import React from 'react';
import Button from 'components/Button';
import ButtonGroup from 'components/ButtonGroup';

type EditActionsButtonsProps = {
  onDismissEdit: () => void;
  onSaveEdit: () => void;
  disabled?: boolean;
  disabledTooltip?: string;
  loading?: boolean;
  align?: 'left' | 'right';
  marginBottom?: string;
  showReupload?: boolean;
  onReupload?: () => void;
};

const EditActionsButtons: React.FC<EditActionsButtonsProps> = ({
  onDismissEdit,
  onSaveEdit,
  disabled = false,
  disabledTooltip,
  loading = false,
  align = 'right',
  marginBottom,
  showReupload = false,
  onReupload,
}) => {
  return (
    <ButtonGroup align={align} marginBottom={marginBottom}>
      {showReupload && onReupload && (
        <Button variant="outlined" onClick={onReupload}>
          Re-upload spreadsheet
        </Button>
      )}
      <Button
        variant="outlined"
        color="secondary"
        onClick={onDismissEdit}
        disabled={loading}
      >
        Clear edits
      </Button>
      <Button
        variant="contained"
        color="primary"
        disabled={disabled}
        onClick={onSaveEdit}
        tooltip={disabledTooltip}
        loading={loading}
      >
        Save edits
      </Button>
    </ButtonGroup>
  );
};

export default EditActionsButtons;
